import { MemberChangeLogViewDto } from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpointDefinition';

export const changeLogRequests = {
  getMemberChangeLogs: EndpointDefinition.get<
    MemberChangeLogViewDto,
    { memberId: string; limit?: number }
  >({
    name: 'getChangeLogs',
    route: '/users/:memberId/change-logs',
  }),
};
